import React from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { AuthenticationError } from "./AuthenticationError";
import { Space, Typography, Button } from "antd";

export const GuestAccountBlock: React.FC = ({ children }) => {
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] || {});
  if (!account) return null;

  if ((account.idTokenClaims as any)["acct"] !== 0) {
    return (
      <AuthenticationError error={null}>
        <Space direction="vertical">
          <Typography.Text>Not a University account</Typography.Text>
          <Typography.Text>
            Please logout and login with the account issued to you by The
            University.
          </Typography.Text>
          <Button type="primary" onClick={() => instance.logout()}>
            Logout
          </Button>
        </Space>
      </AuthenticationError>
    );
  }
  return <>{children}</>;
};
